import Vue from 'vue'
import Qs from 'qs'
import axios from 'axios'
import router from '@/router'
import { i18nRender } from '@/locales'
import { encrypt } from '@/utils/util'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN, ACCESS_SUNID, LANGUAGE } from '@/store/mutation-types'

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: i18nRender('common_globalcomp_login_expired'),
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
}
// 创建 axios 实例
const service = axios.create({
  timeout: 60000 // 请求超时时间
})

const handleError = (error) => {
  const { response } = error

  if (response && response.status) {
    const errorText = codeMessage[response.status] || response.statusText
    const { status, url } = response
    if (status === 401 || `${response.data.code}` === '401') {
      notification.error({
        key: '401',
        message: i18nRender('common_globalcomp_warm_prompt'),
        description: errorText
      })
      Vue.ls.remove(ACCESS_TOKEN)
      Vue.ls.remove(ACCESS_SUNID)

      !location.host.includes('wms-open.eccang.com') && router.replace('/home')
      // location.reload()
      // window.location.href = `http://${window.location.host}/login`
      // Vue.ls.remove(ACCESS_TOKEN)
    } else {
      notification.error({
        message: `${i18nRender('common_globalcomp_warm_prompt')} ${status}: ${url}`,
        description: errorText
      })
    }
  } else if (!response) {
    notification.error({
      description: i18nRender('common_globalcomp_network_server_exception'),
      message: i18nRender('common_globalcomp_network_anomaly')
    })
  }

  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const lang = Vue.ls.get(LANGUAGE) || 'zh_CN'
  config.headers['Accept-Language'] = lang
  const token = Vue.ls.get(ACCESS_TOKEN) // 获得Token
  if (token) {
    config.headers.authorization = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }

  // 需加密API
  const encryptApis = {
    [process.env.VUE_APP_API_SSO_URL + '/user/login']: ['password'],
    [process.env.VUE_APP_API_SSO_URL + '/user/register']: ['password'],
    [process.env.VUE_APP_API_SSO_URL + '/user/userEditPass']: ['newPass', 'oldPass'],
    [process.env.VUE_APP_API_SSO_URL + '/user/firstBindingPhoneEmailPsw']: ['password', 'secondPsw'],
    [process.env.VUE_APP_API_SSO_URL + '/user/addOrEditUserInfo']: ['password'],
    [process.env.VUE_APP_API_SSO_URL + '/dingTalk/registerDingTalkUser']: ['passWord'],
    [process.env.VUE_APP_API_SSO_URL + '/user/retrievePassByPhone']: ['password'],
    [process.env.VUE_APP_API_SSO_URL + '/user/retrievePassByEmail']: ['password'],
    [process.env.VUE_APP_API_SSO_URL + '/user/editStaffPassword']: ['password']
  }
  if (encryptApis[config.url]) {
    for (let i of encryptApis[config.url]) {
      if (config.data[i]?.length) {
        config.data[i] = encrypt(config.data[i])
      }
    }
  }

  // config.headers['Content-Type'] = 'application/json;charset=utf-8'
  // config.data = JSON.stringify(config.data)
  return config
}, handleError)

// response interceptor
service.interceptors.response.use((response) => {
  const { url } = response.config
  const responseBody = response?.data || {}
  if (response.headers.authorization) { // 获取响应头里面的数据，**Authorization根据你响应头里面的数据获取，并不是唯一值**
    Vue.ls.set(ACCESS_TOKEN, response.headers.authorization)
    // console.log('token', response.headers.authorization)
  }
  if (response.data.code === 'common.error.code.0026') {
    Vue.ls.remove(ACCESS_TOKEN)
    Vue.ls.remove(ACCESS_SUNID)
    // window.location.href = `http://${window.location.host}/openapi/index.html#`
    router.replace('/home')
    // Vue.ls.remove(ACCESS_TOKEN)
  }
   // 白名单 | 第三方转发
   const whiteList = [
    '/download'
  ]
  if (whiteList.includes(url.substring(url.lastIndexOf('/')))) {
    return responseBody
  }
  return Qs.parse(response.data)
}, handleError)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
